/* eslint-disable camelcase */
export enum JuridicoFacilTypes {
  GET_INDEX_REQUEST = '@juridico/GET_INDEX_REQUEST',
  GET_INDEX_SUCCESS = '@juridico/GET_INDEX_SUCCESS',
  GET_INDEX_FAILURE = '@juridico/GET_INDEX_FAILURE',
  GET_CONSULT_REQUEST = '@juridico/GET_CONSULT_REQUEST',
  GET_CONSULT_SUCCESS = '@juridico/GET_CONSULT_SUCCESS',
  GET_CONSULT_FAILURE = '@juridico/GET_CONSULT_FAILURE',
  GET_TIPOS_REQUEST = '@juridico/GET_TIPOS_REQUEST',
  GET_TIPOS_SUCCESS = '@juridico/GET_TIPOS_SUCCESS',
  GET_TIPOS_FAILURE = '@juridico/GET_TIPOS_FAILURE',
  GET_AREAS_REQUEST = '@juridico/GET_AREAS_REQUEST',
  GET_AREAS_SUCCESS = '@juridico/GET_AREAS_SUCCESS',
  GET_AREAS_FAILURE = '@juridico/GET_AREAS_FAILURE',
  GET_AREAS_SUBTOPICS_REQUEST = '@juridico/GET_AREAS_SUBTOPICS_REQUEST',
  GET_AREAS_SUBTOPICS_SUCCESS = '@juridico/GET_AREAS_SUBTOPICS_SUCCESS',
  GET_AREAS_SUBTOPICS_FAILURE = '@juridico/GET_AREAS_SUBTOPICS_FAILURE',
  GET_THEMES_REQUEST = '@juridico/GET_THEMES_REQUEST',
  GET_THEMES_SUCCESS = '@juridico/GET_THEMES_SUCCESS',
  GET_THEMES_FAILURE = '@juridico/GET_THEMES_FAILURE',
  GET_LIST_SUBTOPICS_REQUEST = '@juridico/GET_LIST_SUBTOPICS_REQUEST',
  GET_LIST_SUBTOPICS_SUCCESS = '@juridico/GET_LIST_SUBTOPICS_SUCCESS',
  GET_LIST_SUBTOPICS_FAILURE = '@juridico/GET_LIST_SUBTOPICS_FAILURE',
  TYPE_ID_REQUEST = '@juridico/TYPE_ID_REQUEST',
  TYPE_ID_SUCCESS = '@juridico/TYPE_ID_SUCCESS',
  TYPE_ID_FAILURE = '@juridico/TYPE_ID_FAILURE',
  SEARCH_REQUEST = '@juridico/SEARCH_REQUEST',
  SEARCH_SUCCESS = '@juridico/SEARCH_SUCCESS',
  SEARCH_FAILURE = '@juridico/SEARCH_FAILURE',
  LEGISLATION_REQUEST = '@juridico/LEGISLATION_REQUEST',
  LEGISLATION_SUCCESS = '@juridico/LEGISLATION_SUCCESS',
  LEGISLATION_FAILURE = '@juridico/LEGISLATION_FAILURE',
  LAW_REQUEST = '@juridico/LAW_REQUEST',
  LAW_SUCCESS = '@juridico/LAW_SUCCESS',
  LAW_FAILURE = '@juridico/LAW_FAILURE',
  SEARCH_LAW_REQUEST = '@juridico/SEARCH_LAW_REQUEST',
  SEARCH_LAW_SUCCESS = '@juridico/SEARCH_LAW_SUCCESS',
  SEARCH_LAW_FAILURE = '@juridico/SEARCH_LAW_FAILURE',
  AREAS_TEMAS_REQUEST = '@juridico/AREAS_TEMAS_REQUEST',
  AREAS_TEMAS_SUCCESS = '@juridico/AREAS_TEMAS_SUCCESS',
  AREAS_TEMAS_FAILURE = '@juridico/AREAS_TEMAS_FAILURE',
  VIDEO = '@juridico/VIDE0',
  ACCEPT = '@juridico/ACCEPT',
}

export interface LawTypes {
  esfera: string;
  id: number;
  lei: string;
  ocorrencia: number;
  tipo: string;
}

export interface ListLawTypes {
  constituciones: Array<LawTypes>;
  decretos: Array<LawTypes>;
  leis: Array<LawTypes>;
  leis_complementares: Array<LawTypes>;
  medidas_provisorias: Array<LawTypes>;
}

export interface LegislationTypes {
  data_pub: string;
  esfera: string;
  id: number;
  idx: number;
  lei: string;
  ocorrencia: string;
  tipo: string;
}
export interface LeiTypes {
  citacao: string;
  conteudo: string;
  created_at: string;
  data: string;
  ementa: string;
  esfera: string;
  id: number;
  numero: string;
  tipo: string;
  updated_at: string;
}

export interface AcervoTypes {
  fonte?: string;
  court?: string | null;
  texto?: string;
  acordao: string | null;
  area: string;
  ativo: number;
  autor_da_tese: string | null;
  consulta_juridica_area_id: number;
  consulta_juridica_subtema_id: number;
  consulta_juridica_tema_id: number;
  consulta_juridica_tipo_id: number;
  conteudo: string;
  created_at: string;
  data_sessao: string | null;
  dica_em_video: null;
  enunciado: string;
  id: number;
  log_id: null;
  mais_vistos: null;
  recomendado: null;
  referencia: string;
  resumo: string | null;
  subtema: string;
  sumula: null;
  tags: string;
  tema: string;
  tipo: string;
  tipo_de_processo: null;
  updated_at: string;
  video_em_destaque: number;
}

// Abas de texto integral do JusBrasil (INTEIRO_TEOR, RELATORIO_VOTO...). O
// conjunto de labels é aberto: tribunal novo pode trazer label novo.
export interface TextoTypes {
  id: number;
  label: string | null;
  url: string | null;
  conteudo: string | null;
}

export interface AreaCountTypes {
  id: number;
  descricao: string;
  total: number;
}

export interface ReferenceTypes {
  id: number;
  referencia_legal: string;
}

export interface ContentTypes {
  fonte?: string;
  court?: string | null;
  grau?: string | null;
  relator?: string | null;
  processo?: string | null;
  url?: string | null;
  titulo?: string | null;
  acordao: string;
  area: string;
  ativo: boolean;
  autor_da_tese: string;
  consulta_juridica_area_id: number;
  consulta_juridica_subtema_id: number;
  consulta_juridica_tema_id: number;
  consulta_juridica_tipo_id: number;
  conteudo: string;
  created_at: string;
  data_sessao: string;
  dica_em_video: string;
  enunciado: string;
  id: number;
  log_id: number;
  mais_vistos: boolean;
  recomendado: null;
  referencia: string;
  resumo: null;
  subtema: string;
  sumula: string;
  tags: string;
  tema: string;
  tipo: string;
  tipo_de_processo: string;
  updated_at: string;
  video_em_destaque: boolean;
}

export interface ReasonTypes {
  fonte?: string;
  acordao: string;
  area: string;
  ativo: boolean;
  autor_da_tese: string;
  consulta_juridica_area_id: number;
  consulta_juridica_subtema_id: number;
  consulta_juridica_tema_id: number;
  consulta_juridica_tipo_id: number;
  conteudo: string;
  created_at: string;
  data_sessao: string;
  dica_em_video: string | null;
  enunciado: string;
  id: number;
  log_id: number;
  mais_vistos: boolean;
  recomendado: null;
  referencia: string;
  resumo: null;
  subtema: string;
  sumula: string;
  tags: string;
  tema: string;
  tipo: string;
  tipo_de_processo: string;
  updated_at: string;
  video_em_destaque: boolean;
}

export interface ThemeTypes {
  area_id: number;
  descricao: string;
  tema_id: number;
  qnt: number;
  total: number;
}

export interface TypesThemeTypes {
  id: number;
  descricao: string;
  total: number;
}

export interface RecommendedTypes {
  id: number;
  consulta_juridica_tipo_id: number;
  consulta_juridica_area_id: number;
  consulta_juridica_tema_id: number;
  consulta_juridica_subtema_id: number;
  dica_em_video: string | null;
  conteudo: string;
  tipo: string;
  enunciado: string;
}

export interface SuggestionTypes {
  id: number;
  enunciado: string;
  acordao: string;
  data_sessao: string;
  subtema: string;
}

// Filtro "Tribunal" da busca: `court` é a sigla gravada pelo extrator (TCU,
// TCE_MG, CNJ...); `sigla` é a forma de exibição (TCE-MG)
export interface TribunalTypes {
  court: string;
  sigla: string;
  descricao: string;
  qnt: number;
}

export interface JuridicoTypes {
  recomendados: Array<RecommendedTypes>;
  tipo_para_index: Array<TypesThemeTypes>;
  area_para_index: Array<ThemeTypes>;
  tribunais_para_index?: Array<TribunalTypes>;
  tema_para_index: Array<ThemeTypes>;
  mais_vistos: Array<ReasonTypes>;
  video: string;
  conteudo: Array<ContentTypes>;
  textos: Array<TextoTypes>;
  referencia_legal: Array<ReferenceTypes>;
  lista_tipos: Array<TypesThemeTypes>;
  lista_areas: Array<TypesThemeTypes>;
  lista_temas: Array<TypesThemeTypes>;
  lista_subtemas: Array<TypesThemeTypes>;
  acervo: Array<AcervoTypes>;
  search_total_page: number;
  qnt_por_tema_licitacao: Array<TypesThemeTypes>;
  qnt_por_subtema_licitacao: Array<TypesThemeTypes>;
  qnt_por_area_licitacao: Array<TypesThemeTypes>;
  qnt_por_area: Array<AreaCountTypes>;
  qnt_por_tipo_sumula: number;
  qnt_por_tipo_jurisprudencia: number;
  // o backend limita a contagem do JusBrasil; quando bate no teto a tela mostra "500+"
  qnt_por_tipo_jurisprudencia_limitada: boolean;
  qnt_por_tipo_dica: number;
  qnt_leis: number;
  sugestoes: Array<SuggestionTypes>;
  leis: Array<LeiTypes>;
  exibir: Array<LegislationTypes>;
  quantidade_por_lei: Array<ListLawTypes>;
  total_registros: number;
  total_page_area: number;
  video_show: boolean;
  accept: boolean;
}

export interface RequestState {
  index: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  consult: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  tipos: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  areas: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  subtemas: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  search: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  legislation: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  law: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  search_law: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  areas_subtopics: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  tema_area: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
}

export interface JuridicoFacilState {
  juridico: JuridicoTypes;
  readonly request: RequestState;
}
